<template>
	<div
		class="follow-button"
		:class="{
			'-t-dark': darkTheme,
			'-disabled': isDisabled
		}"
		@click="isFollowing ? handleUnfollow(followable) : handleFollow(followable)"
	>
		{{ isFollowing ? $I18n.trans('arena.fan_account.following.unfollow') : $I18n.trans('arena.fan_account.following.follow') }}
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { actions } from '@shared/js/store/modules/following';
import storage from '@shared/js/storage';

export default {
	name:  'FollowButton',
	props: {
		followable: {
			type:     Object,
			required: true,
		},
		isFollowing: {
			type:    Boolean,
			default: false,
		},
		isFollowingInProgress: {
			type:    Boolean,
			default: false,
		},
		isLocked: {
			type:    Boolean,
			default: false,
		},
		darkTheme: {
			type:    Boolean,
			default: true,
		},
	},
	computed: {
		isDisabled() {
			return this.isFollowingInProgress || this.isLocked;
		},
	},
	methods: {
		...mapActions({
			follow:   `following/${actions.FOLLOW}`,
			unfollow: `following/${actions.UNFOLLOW}`,
		}),
		handleFollow(followableItem) {
			if (this.isDisabled) {
				return;
			}
			this.follow(followableItem);
			storage.setCacheTs();
		},
		handleUnfollow(followedItem) {
			if (this.isDisabled) {
				return;
			}
			this.unfollow(followedItem);
			storage.setCacheTs();
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.follow-button {
	--color-text: var(--color-grey-300);
	--color-background: var(--color-grey-850);
	--color-background-hover: var(--color-grey-800);

	@include font-size(fs-80);
	padding: $sp2-5 $sp3-5;
	border-radius: $border-radius--full;
	background-color: var(--color-background);
	color: var(--color-text);
	user-select: none;
	cursor: pointer;

	&.-t-dark {
		--color-text: var(--color-grey-200);
		--color-background: var(--color-grey-700);
		--color-background-hover: var(--color-grey-750);
	}

	&:not(.-disabled):focus,
	&:not(.-disabled):hover {
		background-color: var(--color-background-hover);
	}

	&.-disabled {
		opacity: 0.5;
		cursor: not-allowed;
		pointer-events: none;
	}

}
</style>
